<script lang="ts">
  import Clock from '~icons/mdi/clock-time-four-outline';
  import Star from '~/icons/Star.svelte';
  import Turns from '~/pills/Turns.svelte';
  import Words from '~/pills/Words.svelte';
  import StaticWord from '~/components/StaticWord.svelte';
  import Pill from '~/components/Pill.svelte';
  import BoardTile from '~/board/Tile.svelte';
  import Stats from './Stats.svelte';
  import { isDaily, type Match } from '~/types';
  import { formatSeconds } from '~/utils/dates';
  import { getGame } from '~/store/GameContext.svelte';
  import { slideInOnce } from '~/animations.svelte';

  type Props = {
    words: Match[];
    hideStats?: boolean;
    isLatestDaily?: boolean;
  };
  const props: Props = $props();
  const game = $derived(getGame().current);
</script>

{#if isDaily(game) && !props.hideStats}
  <Stats isLatestDaily={props.isLatestDaily} />
{/if}
<h4 class="result">
  Turns:
  <Turns turns={game.turns} />
</h4>
<h4 class="result">
  Words Made:
  <Words numWords={game.words} />
</h4>
{#if game.duration}
  <h4 class="result">
    Time:
    <Pill value={formatSeconds(game.duration)} class="green">
      <Clock />
    </Pill>
  </h4>
{/if}
{#if isDaily(game)}
  {#if game.finalBoard?.length}
    <h4 class="result">
      <span class="letters-label">Unused letters:</span>
      <div class="letters-container">
        {#each game.finalBoard.flat().filter((t) => t) as tile}
          <BoardTile {tile} size="small" />
        {/each}
      </div>
    </h4>
  {:else}
    <h4 class="result">
      All Clear Bonus
      <Star size="2em" class="green" outlined />
    </h4>
  {/if}
  <h4>Words:</h4>
{:else}
  <h4>Best Words:</h4>
{/if}
<div class="word-list">
  {#each props.words as word}
    <li class="word-container" use:slideInOnce>
      <StaticWord
        {word}
        highlighted={game.mode === 'classic' ? 'green' : undefined}
      />
    </li>
  {/each}
</div>

<style lang="scss">
  @use '../theme/include-media' as *;

  .letters-label {
    text-align: left;
  }
  .letters-container {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 0.2em;
  }
  .word-list {
    display: grid;
    gap: 0.5em;
  }
  .word-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 0.5em;
    @include media('>tablet') {
      padding-bottom: 1em;
    }
    & :global(.word-score) {
      margin: 0;
    }
  }
  .result {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 0.5em;
    margin: 1em 0em;
  }
</style>
